"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeGeneratedToFS = void 0;
var fs_1 = __importDefault(require("fs"));
var path_1 = __importDefault(require("path"));
var constants_1 = require("../constants");
/**
 * Запись нагенерированного в файловую систему.
 * @param {string} dir Директория для записи (если не существует, то будет создана).
 * @param {GeneratedFiles} generated Сгенерированный контент для записи.
 * @param {string?} generateMessage Сообщение, которое добавляется сверху файла (по умолчанию ROBO_COMMENT).
 */
var writeGeneratedToFS = function (dir, generated, generateMessage) {
    if (generateMessage === void 0) { generateMessage = constants_1.ROBO_COMMENT; }
    fs_1.default.existsSync(dir) || fs_1.default.mkdirSync(dir);
    for (var _i = 0, generated_1 = generated; _i < generated_1.length; _i++) {
        var _a = generated_1[_i], file = _a.file, content = _a.content;
        var src = path_1.default.join(dir, file);
        if (fs_1.default.existsSync(src)) {
            fs_1.default.appendFileSync(src, content);
            return;
        }
        fs_1.default.writeFileSync(src, "".concat(generateMessage).concat(content));
    }
};
exports.writeGeneratedToFS = writeGeneratedToFS;
//# sourceMappingURL=writeGeneratedToFS.js.map